<template>
    <div class="my-orders">
        <div class="row">
            <b-table :fields="tableFields" :items="shipRates">
                <template #cell(state)="data">
                    {{data.item.state || "All"}}
                </template>
                <template #cell(legacy_id)="data">
                    {{data.item.legacy_id || "All"}}
                </template>
                <template #cell(ship_rate)="data">
                    <b-input disabled readonly :value="data.item.rate"></b-input>
                </template>
                <template #cell(exclude_multiyear)="data">
                    <b-form-checkbox readonly disabled :checked="data.item.exclude_multiyear == 1"></b-form-checkbox>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import LeftNav from '@/components/dashboard/LeftNav'
export default {
    name: "ShippingRates",
    components: {Navbar, LeftNav},
    computed: {
    },
    data:() => ({
        shipRates: [],
        tableFields: [
            {key: 'state', sortable: true},
            {key: 'legacy_id', sortable: true},
            'ship_rate', 'exclude_multiyear', 'updated_at'
        ]
    }),
    methods: {
        getShippingRates() {
            this.$store.dispatch('getShippingRates').then((result) => {
                this.shipRates = result.data;
                // Sort by state
                this.shipRates.sort((a,b) => {
                    return (a.state >= b.state) ? 1 : -1;
                });
            });
        },
    },

    created() {
        this.getShippingRates();
    }
}
</script>

<style scoped>

</style>